import Lottie from 'lottie-react'
import React from 'react'
import { Link } from 'react-router-dom'

import NotFoundAnimation from 'assets/lottie/404.json'
import Content from 'components/common/Content'
import Text from 'components/common/Text'
import TrackedExternalLink from 'components/common/TrackedExternalLink'
import useAuth from 'hooks/use-auth'
import theme from 'theme'

export const NotFound: React.FC = () => {
  const { hasFaultInjection, hasReliabilityManagement } = useAuth()

  const homeLocation =
    hasReliabilityManagement && !hasFaultInjection ? '/reports/company' : '/'

  return (
    <Content data-test-not-found css={{ margin: 'auto' }}>
      <div css={{ textAlign: 'center' }}>
        <Lottie
          animationData={NotFoundAnimation}
          style={{ width: '80%', maxWidth: 750, margin: '0 auto' }}
        />
        <Text
          as="h1"
          css={{ margin: `${theme.space[4]}px auto`, width: '90%' }}
          data-test-id="not-found-title"
        >
          Everyone has moments of unreliability;
          <br />
          what matters is how you handle them.
        </Text>
        <Text css={{ fontSizes: theme.fontSizes[2] }}>
          The page you're looking for is unavailable.
        </Text>
        <Text css={{ fontSizes: theme.fontSizes[2] }}>
          Head back to <Link to={homeLocation}>home</Link> or check our{' '}
          <TrackedExternalLink href="https://status.gremlin.com">
            status page
          </TrackedExternalLink>
          .
        </Text>
      </div>
    </Content>
  )
}
